import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

// Each row is a button — clicking anywhere on it enters text-edit mode in the
// iframe for that text node. relative + overflow:hidden contain the absolutely-
// positioned hover overlay; min-height keeps the row a comfortable touch target
// even when the truncated text is short.
export const Row = styled.button`
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
	min-height: 32px;
	padding: 8px 10px;
	background: ${({ theme }) => theme.gray[100]};
	border: none;
	border-radius: 6px;
	overflow: hidden;
	box-sizing: border-box;
	text-align: left;
	font: inherit;
	color: inherit;

	&:hover > .text-edit-row-overlay {
		opacity: 1;
	}
`;

export const RowText = styled.div`
	font-size: 13px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	flex: 1;
`;

// Hover-only CTA. Left-aligned to match the text it covers (eye stays anchored
// on the left). Left arrow points back toward the prototype, where the edit
// will happen.
export const HoverOverlay = styled.div.attrs({ className: 'text-edit-row-overlay' })`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 6px;
	padding: 0 10px;
	background: ${({ theme }) => theme.gray[200]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
	font-weight: 500;
	opacity: 0;
	transition: opacity 120ms ease;
	pointer-events: none;
`;

// Quieter weight than Row — visually subordinate, just an "expand the list" toggle.
export const ShowAllButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 6px 10px;
	background: transparent;
	border: none;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[700]};

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;
